import { DatePipe, NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    input,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators, type FormControl } from '@angular/forms';
import { DialogService } from '@pixelgenau/ngx-dialog';
import { finalize, switchMap } from 'rxjs';
import { M020C090InputDatepickerOverlayDialogTag } from '../m020-c090-input-datepicker-overlay/m020-c090-input-datepicker-overlay.dialog';

let errorId = 0;

@Component({
    selector: 'ui-m020-c080-input-datepicker',
    standalone: true,
    imports: [NgClass, DatePipe],
    templateUrl: './m020-c080-input-datepicker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M020C080InputDatepickerComponent {
    Validators = Validators;
    readonly cdr = inject(ChangeDetectorRef);

    dialogService = inject(DialogService);
    destroyRef = inject(DestroyRef);

    control = input.required<FormControl<Date | null>>();
    disabledWeekDays = input<number[]>();
    disabledDays = input<Date[]>();
    minDate = input<Date>();
    maxDate = input<Date>();
    error = input(false, { transform: booleanAttribute });
    errorRequired = input('Bitte wählen Sie Ihren Wunschtermin aus');
    errorValidation = input('Ungültige Eingabe');

    overlayOpen = signal(false);

    errorId = `date-errorId-${errorId++}`;

    async openOverlay(event: MouseEvent): Promise<void> {
        if (event.isTrusted) {
            // Open the overlay
            this.overlayOpen.set(true);
            this.dialogService
                .openDialog(M020C090InputDatepickerOverlayDialogTag, {
                    selected: this.control().value,
                    disabledDays: this.disabledDays(),
                    disabledWeekDays: this.disabledWeekDays(),
                    minDate: this.minDate(),
                    maxDate: this.maxDate(),
                })
                .pipe(
                    takeUntilDestroyed(this.destroyRef),
                    switchMap((result) => result.close$),
                    finalize(() => {
                        this.overlayOpen.set(false);
                    }),
                )
                .subscribe((result) => {
                    this.control().markAsTouched();
                    if (result) {
                        this.control().setValue(result, { emitEvent: false });
                    }
                    this.cdr.detectChanges();
                });
        } else {
            // Overlay opening prevented due to non-user interaction
        }
    }
}
